module.exports = __webpack_public_path__ + "img/download-icon.97bd8ae6.png";